module.exports = __webpack_public_path__ + "img/add-photo-fourth-icon-male.5770aac2.svg";